export const NSW = {
  id: 'NSW',
  userRegionCookieValue: 'nsw',
  shortName: 'NSW',
  longName: 'New South Wales',
  defaultPostcode: '2000',
};

export const QLD = {
  id: 'QLD',
  userRegionCookieValue: 'qld',
  shortName: 'QLD',
  longName: 'Queensland',
  defaultPostcode: '4000',
};

export const VIC = {
  id: 'VIC',
  userRegionCookieValue: 'vic',
  shortName: 'VIC',
  longName: 'Victoria',
  defaultPostcode: '3000',
};

export const TAS = {
  id: 'TAS',
  userRegionCookieValue: 'tas',
  shortName: 'TAS',
  longName: 'Tasmania',
  defaultPostcode: '7000',
};

export const WA = {
  id: 'WA',
  userRegionCookieValue: 'wa',
  shortName: 'WA',
  longName: 'Western Australia',
  defaultPostcode: '6000',
};

export const SA = {
  id: 'SA',
  userRegionCookieValue: 'sa',
  shortName: 'SA',
  longName: 'South Australia',
  defaultPostcode: '5000',
};

export const ACT = {
  id: 'ACT',
  userRegionCookieValue: 'act',
  shortName: 'ACT',
  longName: 'Australian Capital Territory',
  defaultPostcode: '2600',
};

export const NT = {
  id: 'NT',
  userRegionCookieValue: 'nt',
  shortName: 'NT',
  longName: 'Northern Territory',
  defaultPostcode: '0800',
};
